import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    slide: 0,
    currentCount: 0,
    totalCount: 100,
    firstName: '',
    showShare: true,
    video: false,
  },
  mutations: {
    setFirstName: (state, payload) => {
      state.firstName = payload
    },
    gotoSlide: (state, payload) => {
      state.slide = payload.slide
    },
    showShare: (state, payload) => {
      state.showShare = payload
    },
    setCurrentCount: (state, payload) => {
      try {
        state.currentCount = parseInt(payload)
        state.totalCount = calculateTarget(parseInt(payload))
      } catch (e) {
        console.log(e)
        state.currentCount = 0
      }
    },
    showVideo: (state, payload) => {
      state.video = payload
    },
  },
  actions: {

  },
  getters: {
    getThermomWidth: state => {
      return ((state.currentCount / state.totalCount) * 100)
    },
    currentCount: state => {
      return numberWithCommas(state.currentCount)
    },
    totalCount: state => {
      return numberWithCommas(state.totalCount)
    },
  }
})

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

var calculateTarget = function (signatures) {
  if (signatures >= 1000000) {
    return 2000000;
  } else if (signatures >= 900000 && signatures < 1000000) {
    return 900000;
  } else if (signatures >= 800000 && signatures < 900000) {
    return 900000;
  } else if (signatures >= 700000 && signatures < 800000) {
    return 800000;
  } else if (signatures >= 600000 && signatures < 700000) {
    return 700000;
  } else if (signatures >= 500000 && signatures < 600000) {
    return 600000;
  } else if (signatures >= 400000 && signatures < 500000) {
    return 500000;
  } else if (signatures >= 300000 && signatures < 400000) {
    return 400000;
  } else if (signatures >= 250000 && signatures < 300000) {
    return 300000;
  } else if (signatures >= 200000 && signatures < 250000) {
    return 250000;
  } else if (signatures >= 150000 && signatures < 200000) {
    return 200000;
  } else if (signatures >= 125000 && signatures < 150000) {
    return 150000;
  } else if (signatures >= 100000 && signatures < 125000) {
    return 125000;
  } else if (signatures >= 75000 && signatures < 100000) {
    return 100000;
  } else if (signatures >= 50000 && signatures < 75000) {
    return 75000;
  } else if (signatures >= 25000 && signatures < 50000) {
    return 50000;
  } else if (signatures >= 10000 && signatures < 25000) {
    return 25000;
  } else if (signatures >= 5000 && signatures < 10000) {
    return 10000;
  } else if (signatures >= 1000 && signatures < 5000) {
    return 5000;
  } else if (signatures >= 500 && signatures < 1000) {
    return 1000;
  } else if (signatures >= 100 && signatures < 500) {
    return 500;
  } else if (signatures >= 0 && signatures < 100) {
    return 100;
  }
  return 100;
};